import {
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  Input,
  ViewContainerRef
} from '@angular/core';
import {GnTableColumnConfig} from '../TableColumnConfig';
import {formItemTypes} from '../../json-form/json-form-item/FormItem';
import {GnObjectUtils} from 'geminis-ng-core';

@Directive({
  selector: '[gnEditColumn]'
})
export class GnEditColumnDirective {

  private component: ComponentRef<any>;
  private row: any;
  private config: GnTableColumnConfig;

  @Input('row') set setRow(value) {
    this.row = value;
    this.setComponentRow();
  }

  @Input('gnEditColumn') set setColumnConfig(config: GnTableColumnConfig) {
    this.config = config;
    const editType = formItemTypes[config.type];
    if (!editType) {
      throw new Error(`输入组件[${config.type}]未注册`);
    }
    const controlFactory: ComponentFactory<any> = this.resolver.resolveComponentFactory(editType);
    this.component = this.container.createComponent(controlFactory);
    if (config.options) {
      for (const key of Object.keys(config.options)) {
        this.component.instance[key] = config.options[key];
      }
    }
    this.setComponentRow();
  }

  constructor(private resolver: ComponentFactoryResolver,
              private container: ViewContainerRef) {
  }

  private setComponentRow() {
    if (this.component) {
      this.component.instance.writeValue(GnObjectUtils.getValue(this.row, this.config.field));
      this.component.instance.registerOnChange((value) => {
        this.row[this.config.field] = value;
      });
    }
  }

}
